export const manifest = {
  screens: {
    scr_16m9cc: { name: "Executive Summary", route: "/", state: {"slide":0}, position: {"x":160,"y":6160} },
    scr_6b0m9x: { name: "What the KPI funnel tells us", route: "/", state: {"slide":1}, position: {"x":1560,"y":6160} },
    scr_m0935u: { name: "The Challenge", route: "/", state: {"slide":2}, position: {"x":160,"y":8140} },
    scr_1pto8t: { name: "The Opportunity", route: "/", state: {"slide":3}, position: {"x":1560,"y":8140} },
    scr_ya6i47: { name: "The Snakker Solution", route: "/", state: {"slide":4}, position: {"x":2960,"y":8140} },
    scr_has3yx: { name: "Stage 1: Snakkify DermaWorld Anzupgo pages", route: "/", state: {"slide":5}, position: {"x":4360,"y":8140} },
    scr_y7637h: { name: "Stage 2: Activate the Market", route: "/", state: {"slide":6}, position: {"x":160,"y":4180} },
    scr_86teqn: { name: "Campaign Portfolio Recommendation", route: "/", state: {"slide":7}, position: {"x":160,"y":2200} },
    scr_ouu83j: { name: "Recommended Wave 1 Package", route: "/", state: {"slide":8}, position: {"x":160,"y":10120} },
    scr_itq3wu: { name: "Campaign Flow Example", route: "/", state: {"slide":9}, position: {"x":1560,"y":2200} },
    scr_0zyhxa: { name: "Wave 2 Expansion", route: "/", state: {"slide":10}, position: {"x":1560,"y":10120} },
    scr_2o613i: { name: "Measurement & Optimization", route: "/", state: {"slide":11}, position: {"x":160,"y":12100} },
    scr_c53ddk: { name: "Next Steps", route: "/", state: {"slide":12}, position: {"x":160,"y":14080} },
  },
  sections: {
    sec_k9nyik: { name: "Webinar to Series Strategy", x: 0, y: 0, width: 22520, height: 1180 },
    sec_vistwo: { name: "Campaign Execution", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_cieylm: { name: "Operations & Commercial", x: 0, y: 3960, width: 4320, height: 1180 },
    sec_d1j0ex: { name: "Strategic Context", x: 0, y: 5940, width: 2920, height: 1180 },
    sec_wnwk45: { name: "Offerings & Solutions", x: 0, y: 7920, width: 5720, height: 1180 },
    sec_21fwtm: { name: "Campaign Waves & Expansion", x: 0, y: 9900, width: 2920, height: 1180 },
    sec_98cs1p: { name: "Measurement & Optimization", x: 0, y: 11880, width: 1520, height: 1180 },
    sec_a9fiy4: { name: "Conclusion", x: 0, y: 13860, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_k9nyik", children: [] },
    { kind: "section", id: "sec_vistwo", children: [
      { kind: "screen", id: "scr_86teqn" },
      { kind: "screen", id: "scr_itq3wu" },
    ] },
    { kind: "section", id: "sec_cieylm", children: [
      { kind: "screen", id: "scr_y7637h" },
    ] },
    { kind: "section", id: "sec_d1j0ex", children: [
      { kind: "screen", id: "scr_16m9cc" },
      { kind: "screen", id: "scr_6b0m9x" },
    ] },
    { kind: "section", id: "sec_wnwk45", children: [
      { kind: "screen", id: "scr_m0935u" },
      { kind: "screen", id: "scr_1pto8t" },
      { kind: "screen", id: "scr_ya6i47" },
      { kind: "screen", id: "scr_has3yx" },
    ] },
    { kind: "section", id: "sec_21fwtm", children: [
      { kind: "screen", id: "scr_ouu83j" },
      { kind: "screen", id: "scr_0zyhxa" },
    ] },
    { kind: "section", id: "sec_98cs1p", children: [
      { kind: "screen", id: "scr_2o613i" },
    ] },
    { kind: "section", id: "sec_a9fiy4", children: [
      { kind: "screen", id: "scr_c53ddk" },
    ] },
  ],
}
